// Thanks to https://stackoverflow.com/questions/32553158/detect-click-outside-react-component

import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter(ref, handleClickOutside) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutsideHelper(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handleClickOutside(event);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutsideHelper);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutsideHelper);
    };
  }, [ref]);
}

/**
 * Component that alerts if you click outside of it
 */
const OutsideAlerter = (props) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.handleClickOutside);
  return (
    <div ref={wrapperRef} style={{ display: "inline-block" }}>
      {props.children}
    </div>
  );
};
OutsideAlerter.propTypes = {
  children: PropTypes.node,
  handleClickOutside: PropTypes.func,
};
OutsideAlerter.defaultProps = {
  handleClickOutside: () => {},
};

export default OutsideAlerter;
